export const formatPhone = (e: React.ChangeEvent<HTMLInputElement>): void => {
  const input = e.target.value.replace(/\D/g, ''); // Remove all non-digit characters
  const formattedInput = input
    .slice(0, 10)
    .replace(/(\d{3})(\d{3})(\d{1,4})/, '$1 $2 $3')
    .trim();
  e.target.value = formattedInput;
};
